import { createReducer } from '@reduxjs/toolkit';
import {
  authentication,
  logoutUser,
  startImpersonation,
  endImpersonationAction,
  setViewMode,
} from './actions';

const storedTheme = localStorage.getItem('theme');

const readImpersonationFromSession = () => {
  try {
    const raw = sessionStorage.getItem('skusavvy_impersonation');
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return {
    isImpersonating: false,
    impersonatedClientName: null,
    impersonatedClientId: null,
    previousViewMode: null,
    impersonatedOwnerLogoUrl: null,
  };
};

const readViewModeFromSession = () => {
  try {
    const raw = sessionStorage.getItem('skusavvy_view_mode');
    if (raw) return raw;
  } catch (e) {}
  return 'super_admin';
};

const initialState = {
  loading: true,
  isAuthenticated: false,
  isDarkMode: storedTheme && storedTheme === 'light-mode' ? false : true,
  viewMode: readViewModeFromSession(),
  ...readImpersonationFromSession(),
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(authentication.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    })
    .addCase(authentication.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        loading: false,
        isImpersonating: state.isImpersonating,
        impersonatedClientName: state.impersonatedClientName,
        impersonatedClientId: state.impersonatedClientId,
        previousViewMode: state.previousViewMode,
        impersonatedOwnerLogoUrl: state.impersonatedOwnerLogoUrl,
      };
    })
    .addCase(authentication.rejected, (state) => {
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };
    })
    .addCase(startImpersonation, (state, action) => {
      const clientName = action.payload?.clientName ?? null;
      const clientId = action.payload?.clientId ?? null;
      const previousViewMode = action.payload?.previousViewMode ?? null;
      const impersonatedOwnerLogoUrl = action.payload?.ownerLogoUrl ?? null;
      try {
        sessionStorage.setItem(
          'skusavvy_impersonation',
          JSON.stringify({
            isImpersonating: true,
            impersonatedClientName: clientName,
            impersonatedClientId: clientId,
            previousViewMode,
            impersonatedOwnerLogoUrl,
          }),
        );
      } catch (e) {}
      return {
        ...state,
        isImpersonating: true,
        impersonatedClientName: clientName,
        impersonatedClientId: clientId,
        previousViewMode,
        impersonatedOwnerLogoUrl,
      };
    })
    .addCase(endImpersonationAction, (state) => {
      try {
        sessionStorage.removeItem('skusavvy_impersonation');
        sessionStorage.removeItem('skusavvy_client_token');
      } catch (e) {}
      return {
        ...state,
        isImpersonating: false,
        impersonatedClientName: null,
        impersonatedClientId: null,
        previousViewMode: null,
        impersonatedOwnerLogoUrl: null,
      };
    })
    .addCase(setViewMode, (state, action) => {
      const VALID_MODES = ['super_admin', 'owner', 'client'];
      const mode = VALID_MODES.includes(action.payload) ? action.payload : 'super_admin';
      try {
        sessionStorage.setItem('skusavvy_view_mode', mode);
      } catch (e) {}
      return {
        ...state,
        viewMode: mode,
      };
    })
    .addCase(logoutUser, () => {
      try {
        sessionStorage.removeItem('skusavvy_impersonation');
        sessionStorage.removeItem('skusavvy_view_mode');
        sessionStorage.removeItem('skusavvy_client_token');
      } catch (e) {}
      return {
        ...initialState,
        loading: false,
        isImpersonating: false,
        impersonatedClientName: null,
        viewMode: 'super_admin',
      };
    });
});
